import React from "react";

/**
 * Official POG logo (converted from POG-LOGO.eps).
 * Use this anywhere we previously rendered the "POG" wordmark.
 *
 * Props:
 *  - size: height in px (default 48)
 *  - className: extra Tailwind classes
 */
const PogLogo = ({ size = 48, className = "", alt = "POG Spirits logo" }) => {
  return (
    <img
      src="/brand/pog-logo.png"
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      style={{ height: `${size}px`, width: "auto" }}
      className={`inline-block align-middle select-none ${className}`}
      draggable={false}
      data-testid="pog-logo"
    />
  );
};

export default PogLogo;
